<script>
  import { modeBadgeText, normalizeMode } from '../mode.js'

  /** @type {'paper'|'live'|string} */
  export let mode = 'paper'
  /** 'badge' = Hub pill; 'inline' = dashboard eyebrow text */
  export let variant = 'badge'
  /** Kill-switch active in live — red «ОСТАНОВЛЕН» (stop ≠ live color). */
  export let stopped = false

  $: m = normalizeMode(mode)
  $: text = modeBadgeText(m)
</script>

{#if variant === 'inline'}
  <span
    class="pm-mode-badge pm-mode-badge--header"
    class:pm-mode-badge--paper={m === 'paper'}
    class:pm-mode-badge--live={m === 'live'}
    class:pm-mode-badge--killed={stopped}
  >
    {text}{#if stopped}<span class="pm-mode-badge__stop">ОСТАНОВЛЕН</span>{/if}
  </span>
{:else}
  <span
    class="pm-mode-badge pm-mode-badge--hub"
    class:pm-mode-badge--paper={m === 'paper'}
    class:pm-mode-badge--live={m === 'live'}
    class:pm-mode-badge--killed={stopped}
    title={m === 'live' ? 'Живая торговля' : 'Бумага'}
  >
    {text}{#if stopped}<span class="pm-mode-badge__stop">ОСТАНОВЛЕН</span>{/if}
  </span>
{/if}
